import EditButton from "@/components/common/EditButton";
import { useIsFetching } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { Copy } from "../../../../../components/common/Copy";
import Spinner from "../../../../../components/common/Spinner";
import { createGetDiaryKey } from "../../../../diaries/api";
interface Props {
	diaryId: string;
	patientName: string;
	isEditing: boolean;
}
const DiaryTitle = ({ diaryId, patientName, isEditing }: Props) => {
	const isFetching = useIsFetching({ queryKey: createGetDiaryKey(diaryId) });

	return (
		<div className="flex flex-row justify-between items-center lg:py-1 pl-1">
			<div className="flex justify-center items-center gap-x-2">
				<h2 className="text-slate-800 dark:text-slate-200 text-lg">
					<Copy id={`copy-${patientName}`} value={patientName}>
						{patientName}
					</Copy>
				</h2>

				{isFetching ? <Spinner /> : <></>}
			</div>
			<EditButton>
				{isEditing ? (
					<Link
						to="/patients/$diaryId"
						params={{ diaryId }}
						search={(prev) => ({ ...prev })}
					>
						Diary Details
					</Link>
				) : (
					<Link
						to="/patients/$diaryId/edit"
						params={{ diaryId }}
						search={(prev) => ({ ...prev })}
					>
						Patient Details
					</Link>
				)}
			</EditButton>
		</div>
	);
};

export default DiaryTitle;
